// TODO: ZDSU WIP

// type DataLayer = {
//     event: 'GAEvent';
//     eventCategory: 'property_details' | 'signin';
//     eventAction:
//         | 'click'
//         | 'scroll'
//         | 'failure_email'
//         | 'success'
//         | 'keep_me_signed_in';
//     eventLabel?: 'save property';
//     taxonomy?: Record<string, string>;
// };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function triggerTracking(dataLayerObject: any) {
    const dataLayer = window.dataLayer || [];

    Array.isArray(dataLayerObject)
        ? dataLayer.push(...dataLayerObject)
        : dataLayer.push(dataLayerObject);
}
